import login from "./auth/login/loginTh.json";
import common from './common.json'

export const LocalTh = {
  ...login,
  ...common
};
